<template>
    <div v-if="!this.$store.state.isMobile">
        <el-menu
                :default-active="activeIndex2"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b">
            <el-menu-item index="1"  @click="homeClick">
<!--                <img class="demo-image" :src="url" :style="{'top':'0px','height': '48px','background-color':' #545c64'}">-->
<!--                <div class="demo-image" :style="{'top':'0px','height': '10px'}">-->
<!--                    <div class="block">-->
<!--                        <el-image-->
<!--                                style="width: 100px; height: 100px"-->
<!--                                :src="url"-->
<!--                                fit="fill"></el-image>-->
<!--                    </div>-->
<!--                </div>-->
            </el-menu-item>
            <el-submenu index="2">
                <template slot="title">项目</template>
                <el-menu-item index="2-1">
                    <link-p link="/MyselfP">简介</link-p>
                </el-menu-item>

                <el-menu-item index="2-2">
                    <link-p link="/IntroudeceEditorP"> 富文本</link-p>
                </el-menu-item>
                <el-menu-item index="2-3">
                    <link-p link="/LearnEnglishP">背单词</link-p>
                </el-menu-item>
                <el-submenu index="2-4">
                    <template slot="title"><link-p link="/NoteP">笔记</link-p></template>
                    <el-menu-item index="2-4-1"><link-p link="/NoteP">Vue</link-p></el-menu-item>
                    <el-menu-item index="2-4-2">选项2</el-menu-item>
                    <el-menu-item index="2-4-3">选项3</el-menu-item>
                </el-submenu>
                <el-menu-item index="2-5">
                    <link-p link="/Mall">商城</link-p>
                </el-menu-item>
            </el-submenu>
            <el-menu-item index="3" disabled>消息中心</el-menu-item>
            <el-menu-item index="4"><div @click="loginClick">登录</div></el-menu-item>
        </el-menu>
    </div>
</template>

<script>
    import Link from "../../../link/Link";
    import LinkP from "../../../link/LinkP";
    import logo from "../../../assets/img/home/logo1.svg";
    export default {
        name: "NavMenu",
        components:{
            Link,
            LinkP
        },
        data() {
            return {
                activeIndex: '1',
                activeIndex2: '1',
                url:logo,
            };
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
            loginClick(){
                this.$router.replace('/LoginP')
            },
            homeClick(){
                this.$router.replace('/Home')
            }
        }
    }
</script>

<style scoped>
fdf{
    height: 30px;
}
</style>